import '../static/GradientCircle.css';
import React__default from "react";
import clsx from "clsx";
const gradientCircle = `_gradientCircle_cd14f71`;
const styles = { gradientCircle };
const GradientCircle = ({
  className
}) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: clsx(styles.gradientCircle, className) });
};
export {
  GradientCircle as G
};
//# sourceMappingURL=GradientCircle.DJjs_WuT.mjs.map
